import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { validateBoardSearch } from '@/features/buying/order-guide/api';
import { BoardScreen } from '@/features/buying/order-guide/BoardScreen';

/**
 * /purchasing/guide — the order guide board (TASK-0229). Un-nested from
 * /purchasing (the `_` suffix) so it does not inherit the PO list's search
 * schema or its Outlet switch. The screen lives in features/buying/order-guide.
 */
export const Route = createFileRoute('/_app/purchasing_/guide')({
  staticData: { crumb: 'Order guide' },
  validateSearch: validateBoardSearch,
  component: OrderGuideBoardRoute,
});

function OrderGuideBoardRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <BoardScreen
      search={search}
      onSearch={(patch, options) =>
        void navigate({
          search: (prev) => ({ ...prev, ...patch }),
          replace: options?.replace ?? false,
        })
      }
    />
  );
}
